import axios from "axios";
import authHeader from "./auth-header";
import { APP_URL } from "./http-common";

const URLEntityName = APP_URL + "oshma";

const getAllOshmas = (page, searchValue, limit, filterSelect) => {
  var valueOshma = "";
  var pageValue = page;
  if (searchValue !== "") {
    if (filterSelect) {
      valueOshma = "&search=status=ACTIVE&name=" + searchValue;
    } else {
      valueOshma = "&search=name=" + searchValue;
    }
  } else {
    if (filterSelect) {
      valueOshma = "&search=status=ACTIVE";
    } else {
      valueOshma = "";
    }
  }
  var valueLimit = "";
  if (limit !== "" && limit !== undefined) {
    pageValue = 0;
    valueLimit = "&size=" + limit;
  }

  return axios
    .get(URLEntityName + "?page=" + pageValue + valueOshma + valueLimit, {
      headers: authHeader(),
    })
    .then((response) => {
      return response.data;
    });
};

async function deleteOshma(id) {
  await axios
    .delete(URLEntityName + "/" + id, { headers: authHeader() })
    .then((response) => {
      if (
        response.status === 200 ||
        response.status === 201 ||
        response.status === 204
      ) {
        return response;
      }
      //return response;
    })
    .catch((err) => {
      return err;
    });
}

async function createOshma(oshma) {
  await axios
    .post(URLEntityName, oshma, {
      headers: authHeader(),
    })
    .then((response) => {
      return response;
    });
}

async function updateOshma(oshma) {
  await axios
    .put(URLEntityName + "/" + oshma.id, oshma, {
      headers: authHeader(),
    })
    .then((response) => {
      return response;
    });
}

const getOshmaById = (id) => {
  return axios
    .get(URLEntityName + "/" + id, { headers: authHeader() })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return err;
    });
};

const oshmaService = {
  getAllOshmas,
  getOshmaById,
  createOshma,
  deleteOshma,
  updateOshma,
};
export default oshmaService;
